export const GEOBLOCK_LIST = [
	{ code: 'AG', name: 'Antigua and Barbuda' },
	{ code: 'DZ', name: 'Algeria' },
	{ code: 'BD', name: 'Bangladesh' },
	{ code: 'BO', name: 'Bolivia' },
	{ code: 'BY', name: 'Belarus' },
	{ code: 'BI', name: 'Burundi' },
	{ code: 'MM', name: 'Burma (Myanmar)' },
	{ code: 'CI', name: "Cote D'Ivoire (Ivory Coast)" },
	{ code: 'CU', name: 'Cuba' },
	{ code: 'CD', name: 'Democratic Republic of Congo' },
	{ code: 'EC', name: 'Ecuador' },
	{ code: 'IR', name: 'Iran' },
	{ code: 'IQ', name: 'Iraq' },
	{ code: 'LR', name: 'Liberia' },
	{ code: 'LY', name: 'Libya' },
	{ code: 'ML', name: 'Mali' },
	{ code: 'MA', name: 'Morocco' },
	{ code: 'NP', name: 'Nepal' },
	{ code: 'KP', name: 'North Korea' },
	{ code: 'SO', name: 'Somalia' },
	{ code: 'SD', name: 'Sudan' },
	{ code: 'SY', name: 'Syria' },
	{ code: 'VE', name: 'Venezuela' },
	{ code: 'YE', name: 'Yemen' },
	{ code: 'ZW', name: 'Zimbabwe' },
	{ code: 'US', name: 'United States' },
];
